import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface Tag {
  id: number;
  name: string;
}

@Component({
  selector: 'app-tags',
  standalone: false,
  templateUrl: './tags.html',
  styleUrl: './tags.scss',
})
export class Tags implements OnInit{
   pageTitle = 'Tag List';

  pageSubtitle =
    'View, manage, and organize all course tags in one place.';

  searchTerm = '';

  page = 1;
  pageSize = 10;

  tags: Tag[] = [
    {
      id: 1,
      name: 'Design',
    },
    {
      id: 2,
      name: 'Development',
    },
    {
      id: 3,
      name: 'Digital marketing',
    },
    {
      id: 4,
      name: 'IT',
    },
    {
      id: 5,
      name: 'Math',
    },
    {
      id: 6,
      name: 'Music',
    },
    {
      id: 7,
      name: 'Programming',
    },
    {
      id: 8,
      name: 'Science',
    },
    {
      id: 9,
      name: 'Travel',
    },
  ];

  filteredTags: Tag[] = [];

  constructor(
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.applyFilters();
  }

  get paginatedTags(): Tag[] {
    const startIndex =
      (this.page - 1) * this.pageSize;

    const endIndex =
      startIndex + this.pageSize;

    return this.filteredTags.slice(
      startIndex,
      endIndex
    );
  }

  get startItem(): number {
    if (this.filteredTags.length === 0) {
      return 0;
    }

    return (
      (this.page - 1) * this.pageSize + 1
    );
  }

  get endItem(): number {
    return Math.min(
      this.page * this.pageSize,
      this.filteredTags.length
    );
  }

  onSearchChange(): void {
    this.page = 1;
    this.applyFilters();
  }

  onPageSizeChange(event: Event): void {
    const selectElement =
      event.target as HTMLSelectElement;

    this.pageSize = Number(
      selectElement.value
    );

    this.page = 1;
  }

  applyFilters(): void {
    const normalizedSearch =
      this.searchTerm
        .trim()
        .toLowerCase();

    this.filteredTags =
      this.tags.filter((tag) =>
        tag.name
          .toLowerCase()
          .includes(normalizedSearch)
      );

    const lastAvailablePage = Math.max(
      1,
      Math.ceil(
        this.filteredTags.length /
          this.pageSize
      )
    );

    if (this.page > lastAvailablePage) {
      this.page = lastAvailablePage;
    }
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.page = 1;

    this.applyFilters();
  }

  addTag(): void {
    this.router.navigate([
      '/admin/course-reference/add-tag'
    ]);
  }

  editTag(tag: Tag): void {
    this.router.navigate([
      '/admin/course-reference/tag/edit',
      tag.id
    ]);
  }

  deleteTag(tag: Tag): void {
    console.log(
      'Delete tag:',
      tag
    );
  }

  trackByTagId(
    _index: number,
    tag: Tag
  ): number {
    return tag.id;
  }
}
